import classNames from 'classnames';
import React, { FC } from 'react';
import { Typography } from '../Typography';
import styles from './PromoCard.module.scss';

type PromoCardLinkProps = {
	className?: string;
};

export const PromoCardLink: FC<PromoCardLinkProps> = ({ className, children }) => {
	return (
		<Typography as="p" variant="perex" className={classNames(styles.promoCardLink, className)}>
			{children}
		</Typography>
	);
};
